/**
 * Revit category lists that define the connector parameter routing matrix.
 *
 * This module deliberately has ZERO imports: the live E2E specs run in Node
 * and assert the exact category route of each mode, so they must be able to
 * read these lists without loading the browser gRPC runtime (which touches
 * `window` at module scope). `connectorPlan.ts` re-exports them, so callers
 * inside the app keep their existing import path.
 */

/** Categories whose connector parameters always live on the project, even in Family modes. */
export const PIPE_SYSTEM_CONNECTOR_CATEGORIES = [
  'Pipes',
  'Flex Pipes',
  'FlexPipes',
];

/** Categories whose connector parameters a Family mode writes into the editable family. */
export const EDITABLE_FAMILY_CONNECTOR_CATEGORIES = [
  'Pipe Fittings',
  'Pipe Accessories',
  'Generic Models',
  'Mechanical Equipment',
];

/** Every category a Project mode binds in its single project mutation. */
export const CONNECTOR_PARAMETER_CATEGORIES = [
  'Pipes',
  'Flex Pipes',
  'Pipe Fittings',
  'Pipe Accessories',
  'FlexPipes',
  'Generic Models',
  'Mechanical Equipment',
];
